export default "__VITE_ASSET__BJM9jYhd__"